//
//
//
//
//
//

import openURL from 'quasar/src/utils/open-url.js';;
import moment from 'moment';
export default {
  name: 'PageFooter',
  data: function data() {
    return {
      moment: moment
    };
  },
  methods: {
    openURL: openURL
  }
};